import { render, staticRenderFns } from "./Fixedvehicle.vue?vue&type=template&id=99621d64&scoped=true&"
import script from "./Fixedvehicle.vue?vue&type=script&lang=js&"
export * from "./Fixedvehicle.vue?vue&type=script&lang=js&"
import style0 from "./Fixedvehicle.vue?vue&type=style&index=0&id=99621d64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99621d64",
  null
  
)

component.options.__file = "Fixedvehicle.vue"
export default component.exports